import { Theme } from "@mui/material";
import { Dayjs } from "dayjs";
import ReactDOMServer from "react-dom/server";
import { ChartTooltipFormatterParams } from "src/components/Dashboard/interfaces/DashboardComponentParams";
import { IntervalTab } from "src/components/IntervalTabs/enum/IntervalTab";
import { MeasuresSummarizedItemDto } from "src/types/dashboardDatasetDto";

import { TooltipDiffRow } from "../TooltipDiffRow";
import { TooltipWrapper } from "../TooltipWrapper";
import { formatTooltipDate } from "../utils/tooltipUtils";

export function chartLiveSectionTooltipFormatter(
  params: ChartTooltipFormatterParams,
  sortedChartData: MeasuresSummarizedItemDto[],
  currentDate: Dayjs,
  pastDate: Dayjs,
  theme: Theme
): string {
  const list = Array.isArray(params) ? params : [params];
  const paramsData = list[0];

  const item = sortedChartData.find((e: MeasuresSummarizedItemDto) => e.localName === paramsData.name);
  const pastValue = item?.pastValue ?? null;
  const currentValue = paramsData.value;
  params.seriesName = paramsData.name;

  const tooltipDate = formatTooltipDate(currentDate, pastDate);

  const row = (
    <TooltipDiffRow
      param={params}
      firstValue={currentValue as unknown as number}
      secondValue={pastValue as number | undefined}
      theme={theme}
      expectedVisitors={null}
      intervalTab={IntervalTab.Day}
      showColorSpan={false}
      hasWeather={false}
    />
  );

  return ReactDOMServer.renderToString(
    <TooltipWrapper date={tooltipDate} theme={theme}>
      {row}
    </TooltipWrapper>
  );
}
